module.exports = __webpack_public_path__ + "img/card_220150555.0d686b9e.jpg";